import { render, staticRenderFns } from "./house-add.vue?vue&type=template&id=14bc1a53&scoped=true&"
import script from "./house-add.vue?vue&type=script&lang=js&"
export * from "./house-add.vue?vue&type=script&lang=js&"
import style0 from "./house-add.vue?vue&type=style&index=0&id=14bc1a53&scoped=true&lang=css&"
import style1 from "./house-add.vue?vue&type=style&index=1&id=14bc1a53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bc1a53",
  null
  
)

export default component.exports